import { createFileRoute } from "@tanstack/react-router";
import { ChangesList } from "@/components/tabs/ChangesList";

export const Route = createFileRoute("/changes/")({
  component: ChangesList,
});
